import { createContext } from "react";

// The Privacy Mode context lives in its own module, separate from HideDataProvider.
//
// Why: `useHideData` is imported by <HiddenValue>, and <HiddenValue> is imported by ~80 files —
// effectively every screen that shows a price or a name. If the hook had to import the provider
// to get the context, all of those files would transitively pull in the GraphQL client, because
// the provider needs it to persist the setting. That showed up as Amplify configuration warnings
// in tests for components that have nothing to do with GraphQL, and it puts the API client into
// chunks that do not need it.
//
// The provider imports this; consumers import this. Nothing that only READS the mode has to know
// how it is written.
//
// Since the store moved into helpers/hideData.js, this context carries only `saveConfig`. The
// state and the switch come from the store, which useHideData subscribes to — so a consumer
// rendered OUTSIDE the provider still masks correctly and merely cannot save preferences.
// It used to see the mode as "off", which removed the very masking a test was checking.
const HideDataContext = createContext({
  saveConfig: () => Promise.resolve(),
});

export default HideDataContext;
